import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import {
  getProjectDetails,
  ProjectDetails,
} from '@/features/projects/shared/api/get-project-details';

type QueryResult = ProjectDetails;

type Props = {
  projectId: string;
  queryProps?: UseQueryOptions<QueryResult, unknown, QueryResult>;
};

export const getProjectDetailsQueryKey = (projectId: string) => [
  'projects',
  projectId,
];

export const useProjectDetails = ({ projectId, queryProps }: Props) => {
  return useQuery({
    ...queryProps,
    queryKey: getProjectDetailsQueryKey(projectId),
    queryFn: async () => {
      const project = await getProjectDetails({ projectId: projectId });
      return project;
    },
  });
};
